export default () => {
  const wrapper = document.querySelector(`[load-list]`);

  if (!wrapper) {
    return;
  }

  const wrapperData = document.querySelector(`[data-count]`);

  if (!wrapperData) {
    return;
  }

  const counter = wrapperData.dataset.count

  let cards;
  let totalCards;

  const initFakeLoadMore = () => {
    const loadMoreBtn = document.querySelector('.load-more-btn-box');
    if (!loadMoreBtn) {
      return;
    }
   
    cards = [...document.querySelectorAll('.load-more-card')];

    totalCards = cards.length;

    if (cards.length > counter) {
      loadMoreBtn.style.display = 'block';
    } else {
      loadMoreBtn.style.display = 'none';
    }
    cards.forEach((card) => {
      card.style.display='block';
    })

    cards.forEach((card, i) => {
      if(i >= counter) {
        card.style.display='none';
      }
    })

    loadMoreBtn.addEventListener('click', () => {
      cards.forEach((card) => {
        card.style.display='block';
      })

      loadMoreBtn.style.display = 'none';
    })
  }

  initFakeLoadMore();
  
}